import { useSession } from '.'
import { RequiredSessionError } from './errors'

interface RequiredSession {
  isUserAuthenticated: true
  userId: string
  isUserRoot: boolean
}

export function useRequiredSession(): RequiredSession {
  const { state } = useSession()
  const { isUserAuthenticated, userId, isUserRoot } = state

  if (!isUserAuthenticated) {
    throw new RequiredSessionError('User is not authenticated')
  }

  if (!userId) {
    throw new RequiredSessionError('User ID is missing')
  }

  return {
    isUserAuthenticated,
    userId,
    isUserRoot,
  }
}
